const phoneCodes = [
  // Southeast Asia
  { code: "+65", country: "SG" }, // Singapore
  { code: "+60", country: "MY" }, // Malaysia
  { code: "+62", country: "ID" }, // Indonesia
  { code: "+66", country: "TH" }, // Thailand
  { code: "+63", country: "PH" }, // Philippines
  { code: "+84", country: "VN" }, // Vietnam
  { code: "+673", country: "BN" }, // Brunei
  { code: "+855", country: "KH" }, // Cambodia
  { code: "+856", country: "LA" }, // Laos
  { code: "+95", country: "MM" }, // Myanmar

  // South Asia
  { code: "+91", country: "IN" }, // India
  { code: "+92", country: "PK" }, // Pakistan
  { code: "+880", country: "BD" }, // Bangladesh
  { code: "+94", country: "LK" }, // Sri Lanka

  // East Asia
  { code: "+86", country: "CN" }, // China
  { code: "+852", country: "HK" }, // Hong Kong
  { code: "+853", country: "MO" }, // Macau
  { code: "+81", country: "JP" }, // Japan
  { code: "+82", country: "KR" }, // South Korea

  // Western markets
  { code: "+1", country: "US" }, // USA
  { code: "+44", country: "UK" }, // United Kingdom
  { code: "+61", country: "AU" }, // Australia
];

export default phoneCodes;
